module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921062649_T.849bbda9.jpg";